export const VIEWPORT_MARGIN = 8
export const KEYBOARD_STEP = 16

export const clamp = (value, min, max) => Math.min(Math.max(value, min), Math.max(min, max))

// The site navbar is fixed above the studio, so the window must stay below it.
export const getMinTop = () => (
  (document.querySelector('.wayfinder')?.getBoundingClientRect().bottom ?? 0) + VIEWPORT_MARGIN
)
